<template>
  <main id="container" class="page-container bg-wave5">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="이벤트" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-festivalChallenge">
      <div class="container">
        <div class="page-sub-header">
          <!-- <h3 class="page-sub-title">
            <span class="green">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3> -->
        </div>
      </div>
            <div class="page-tab-container">
        <div class="container tab-buttons">
          <!-- <router-link to="delivery" class="tab-button"
            >공공배달앱 이용후기</router-link
          >
          <router-link to="digitalOnnuri" class="tab-button" 
            >디지털온누리 이벤트</router-link
          > -->
          <router-link to="dosirak" class="tab-button" 
            >동행도시락 구매인증 이벤트</router-link
          >
          <router-link to="slogan" class="tab-button" 
            >동행축제 슬로건 찾기 이벤트</router-link
          >
          <router-link to="festivalChallenge" class="tab-button is-active" 
            >지역축제 1만원 챌린지 이벤트</router-link
          >
          <router-link to="myPlace" class="tab-button" 
            >나만의 동행 플레이스 이벤트</router-link
          >
        </div>
      </div>
      <div class="container">

        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/festivalChallenge_main.png"
                  alt="지역축제 1만원 챌린지 이벤트"
                  style="width: 100%; max-width: 1000px;"
                />
              </div>
            </div>
            <div class="event-check-header-info">
              <ul class="event-check-header-info-list">
                <li v-for="(item, idx) in infoList" :key="idx">
                  <span class="infolist-title">{{ item.title }}</span>
                  <div class="infolist-text-wrapper">
                  <span class="infolist-text" v-html="item.detail" style="overflow-wrap: break-word;"></span>
                   <!-- <router-link v-if="item.title === '결과발표'" to="winPage" class="infolist-title">베스트리뷰 보기</router-link> -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-guide">
            <span class="event-check-guide-title">참여방법</span>
            <div class="event-check-guide-desc no-border">
              <ul class="event-check-guide-desclist">
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/02-1.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 1</span>
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <span class="desclist-text"
                        >지역축제에서 1만원 이상 소비하기
                        <div class="desclist-tag">
                          <span>지역축제 : 동행축제 누리집 ‘방방곡곡 동행축제’ 배너 클릭하여 확인</span>
                          <span class="accept-button"><a href="#" @click.prevent="clickLink($router.resolve({ name: 'Festival' }).href)">지역축제 찾기</a></span>
                        </div>
                      </span>
                    </div>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/02-2.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 2</span>
                    <span class="desclist-text">
                      구매한 제품(or 음식), 구매 영수증과 지역축제 제작물 같이 촬영
                      <div class="desclist-tag">
                          <span>배너, 포스터, 현수막 등 지역축제명이 보이는 축제 제작물과 영수증 사진 촬영 필수</span>
                      </div>
                    </span>
                  </div>
                  
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/02-4.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 3</span>
                    <span class="desclist-text">개인 SNS에 사진 업로드하고, 동행축제 누리집에서 네이버폼 접수</span>
                    <div class="desclist-tag">
                      <span>구매한 제품(or 음식)& 축제사진 SNS 업로드 (필수 해시태그: #동행축제, #소비축제)</span> 
                    </div>
                    <div class="desclist-tag">
                      <span>영수증(or 결제내역), 지역축제 방문 인증사진 네이버폼에 접수</span>
                    </div>
                  </div>
                </li>
                <li class="event-check-guide-desclist-li">
                  <div class="event-check-guide-desclist-img hidden-mobile">
                    <img src="@/assets/img/event/02-3.png" alt="" />
                  </div>
                  <div class="event-check-guide-desclist-text">
                    <span class="desclist-title">STEP 4</span>
                    <span class="desclist-text">경품 수령을 위한 개인 정보 입력 후 접수</span>
                    <div class="desclist-tag" v-if="isShowBtn">
                      <span style="font-weight: bold; word-break: break-all;">* 네이버폼 : https://naver.me/FytElqr9</span>
                      <span class="accept-button"><a href="https://naver.me/FytElqr9" target="_blank">접수하기</a></span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="event-check-products">
            <span class="event-check-products-title">경품안내</span>
            <ul class="event-check-products-list">
              <li
                class="event-check-products-list-li"
                v-for="(item, idx) in prdList"
                :key="idx"
              >
                <div class="event-check-products-item">
                  <div class="event-check-products-item-img" style="height: 200px;">
                    <img
                      :src="require(`@/assets/img/event/${item.img}`)"
                      :alt="item.title"
                      style="position: static; transform: none; width: 100%; height: 200px; display: block; object-fit: contain;"
                    />
                  </div>
                  <div class="event-check-products-item-title">
                    <span class="item-title-wrap">
                      <div class="item-title">{{ item.title }}</div>
                      <div class="item-wrap">
                        <span class="item" v-if="item.person">{{ item.person }}</span>
                        <span class="item" v-if="item.person2">{{ item.person2 }}</span>
                      </div>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="event-check-button-box">
        <div class="container flex-column">
          <span class="event-check-prect-title">당첨안내</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in festivalChallengeInfo"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
      
          <!-- <button type="button"  v-if="isShowBtn" class="event-check-button" @click="clickLink('https://naver.me/5neaoDUO')">이용후기 이벤트 참여</button>  -->
        </div>
        <div class="container flex-column">
          <span class="event-check-prect-title">경품발송</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in festivalChallengeList"
              :key="idx"
            >
              <span class="prect-list-text" v-html="item"></span>
            </li>
          </ul>
          <div class="into-area" style="width: 100%; text-align: center">
            <button
              type="button"
              v-if="isShowBtn"
              class="event-check-button"
              @click="clickLink('https://naver.me/FytElqr9')"
            >
              참여하기
            </button>
            <!-- <span class="into-button"><a href="https://naver.me/5bV9JGrN" target="_blank">참여하기</a></span> -->
          </div>
        </div>
      </div>
      <div class="event-check-prect">
        <div class="container">
          <span class="event-check-prect-title">유의사항</span>
          <ul class="event-check-prect-list">
            <li
              class="event-check-prect-list-li"
              v-for="(item, idx) in prectList"
              :key="idx"
            >
              <div class="prect-list-text" v-html="item"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<style>
.accept-button a {
  width: 110px; /* 버튼 너비 유지 */
  height: 25px; /* 버튼 높이 유지 */
  border-radius: 7px;
  display: inline-flex;
  background-color: #f780af;
  color: #ffffff;
  font-size: 17px;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
}

.infolist-text-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

.infolist-text-wrapper .infolist-title {
  margin-top: 17px;
  margin-left: 15px;
  flex-shrink: 0;
  text-decoration: none;
}

.prect-list-text a {
  word-break: break-all;
}

.desclist-text-small a {
  /* 긴 URL이 영역을 벗어나지 않도록 줄바꿈 처리합니다. */
  word-break: break-all;
}

@media (max-width: 768px) {
  .infolist-text-wrapper .infolist-title {
    margin-left: 11px;
  }
  .desclist-title,
  .desclist-text,
  .desclist-text-small,
  .desclist-text-bold {
    font-size: 16px !important;
  }
}
</style>
<script>
import PageHeader from "@/components/content/PageHeader";
export default {
  name: "EventFestivalChallenge",
  components: { PageHeader },
  data: () => ({
    visibleModal: false,
    infoList: [
      {
        title: "참여기간",
        // detail: "2025년 11월 1일(토) ~ 2025년 11월 30일(일)<br><span style='font-size: 16px'* 베스트리뷰어 1주차 11.1~11.9, 2주차 11.10~11.16, 3주차 11.17~11.23, 4주차 11.24~11.30</span>",
        detail: "2026년 4월 11일(토) ~ 2026년 5월 10일(일)",
      },
      {
        title: "결과발표",
        detail: "2026년 6월 중",
      },
      {
        title: "경품발송",
        detail: "2026년 7월 중",
      },
      {
        title: "진행방식",
        detail:
          "지역축제에서 1만원 이상 구매 후, 구매 제품 촬영하여 개인 SNS에 업로드하고 영수증과 함께 누리집 이벤트 페이지에서 네이버폼 접수",
      },
    ],
    prdList: [
      {        
        img: "onnuri_0327.png",
        title: "디지털 온누리상품권",
        person: " 50만원 1명",
        person2: "5만원 10명",
      },
      {
        img: "chicken_0327.png",
        title: "치킨+콜라 쿠폰",
        person: "(40명)",
      },
    ],
    festivalChallengeInfo: [
      "네이버폼 접수자 대상 미션 검수 후, 추첨을 통해 당첨자 선정",
    ],
    festivalChallengeList: [
      "네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
      "5만원 이하 경품 : 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
      "5만원 초과 경품 : 개별 연락 후 제세공과금(22%) 납부 안내와 개인정보, 고유식별정보 수집·이용 및 제공 동의 → 제세공과금 납부 확인 후 네이버폼 접수 시 기재한 핸드폰 번호로 모바일 쿠폰 전송",
    ],

    prectList: [
      "본 이벤트는 동행축제 기간 내 연계 지역축제 방문 후, 1만원 이상 소비 후 동행축제 누리집 온라인 이벤트 페이지에서  참여하기 버튼을 클릭하여 접수 해주시면 응모 완료 됩니다.",
      '동행축제 연계 50개 지역축제만 인정 되며, 참여 기준 적합자중 랜덤으로 추첨을 진행합니다.',
      '동행축제 이벤트 기간 내 접수해주신 건만 인정됩니다.',
      '해당 이벤트에 만 14세 미만은 참여할 수 없습니다. (만 14세 미만 참여자의 경우 경품 당첨이 취소 됩니다.)',
      "중복 접수 시 미션 기준에 충족하는 응모 1건만 인정 처리 됩니다.",
      "베스트리뷰어 선정 시 네이버폼에 접수한 리뷰 이미지가 홍보물로 사용됩니다.",
      "5만원 초과 경품 당첨의 경우 제세공과금(22%)는 본인이 부담해야 합니다.",
      '디지털 온누리상품권의 경우 디지털온누리앱에 선물하기를 통해 경품 지급될 예정입니다. <br>*구글플레이스토어 : <a href="https://play.google.com/store/apps/details?id=com.komsco.kpay" target="_blank">https://play.google.com/store/apps/details?id=com.komsco.kpay</a><br>*앱스토어 : <a href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450" target="_blank">https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450</a>',
      '이름과 휴대폰 번호가 디지털온누리앱 가입 정보와 일치한 경우에만 선물을 받을 수 있습니다.',
      "당첨자의 잘못된 정보 입력으로 인해 경품 누락이 될 경우 재발송되지않습니다.",
      "지급된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.",
      "당첨 쿠폰이 분실 및 도난 된 경우, 재발송 불가합니다. (당첨 쿠폰 복사 및 저장 필수)",
      "이벤트 참여 응모를 위한 네이버폼으로 취합 된 개인 정보는 이벤트 경품 발송 절차가 모두 완료된 이후에 즉시 폐기 됩니다.",
      "지급 된 쿠폰 사용 시, 발송된 쿠폰 내 유의사항을 반드시 확인 바랍니다.",
      '당첨자는 이벤트 종료 후, 26년 7월 중 누리집에 공지될 예정입니다.',
      '이벤트 일정 및 경품 내역은 추후 주최 측의 사정에 따라 변동 가능합니다.',
      '이벤트에 관한 문의는 대행사인 <span style="font-weight: bold;">㈜지엠컴 070-4838-6391</span>로 문의 바라며, 상담 가능 시간은 평일 오전 10시 ~ 오후 7시입니다.',
    ],
  }),
  computed: {
    isShowBtn() {
      return new Date() > new Date("2026-04-11 00:00:00") &&
        new Date() < new Date("2026-05-10 23:59:59");
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const thisTab = document.querySelector(".tab-button.is-active");
        thisTab.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 100);
    });
  },
  methods: {
    clickLink(url) {
      window.open(url, "_blank");
    },
    clickEvent(e) {
      let url = "https://naver.me/5neaoDUO";
      const w = 560;
      const h = 600;
      const title = "이벤트";

      // 브라우저 창의 크기 가져오기
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      // 팝업창의 중앙 좌표 계산
      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      // 팝업창 설정
      const options = `
				scrollbars=yes,
				width=${w},
				height=${h},
				top=${top},
				left=${left},
				status=no,
				menubar=no,
				toolbar=no,
				location=no,
				directories=no,
				copyhistory=no
			`.replace(/\s+/g, "");

      // 팝업창 열기
      const newWindow = window.open(url, title, options);

      // 팝업창이 차단되었는지 확인
      if (window.focus && newWindow) {
        newWindow.focus();
      }

      return newWindow;
    },
  },
  metaInfo() {
    return {
      title: "지역축제 1만원 챌린지 이벤트 | 동행축제",
      link: [
        {
          rel: "canonical",
          href: "https://www.k-shoppingfesta.org/ko/event/festivalChallenge",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://www.k-shoppingfesta.org/ko/event/festivalChallenge",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://www.k-shoppingfesta.org/ko/event/festivalChallenge",
        },
      ],
    };
  }
};
</script>
